export default __webpack_public_path__ + "static/media/file-text 3.5fe53ca5.svg";